"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnalyticsAPIResponse = exports.useAnalyticsLoad = exports.useAnalytics = exports.generateAnalyticsFn = exports.pushAnalyticsBase = exports.getAnalyticsEventObject = exports.analyticsPush = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var types_1 = require("../types");
/** Push analytics payload to datalayer @deprecated */
function analyticsPush(payload) {
    if (window.dataLayer) {
        window.dataLayer.push(payload);
    }
    else {
        console.warn('no dataLayer found', payload);
    }
}
exports.analyticsPush = analyticsPush;
/** Build an analytics payload @deprecated */
function getAnalyticsEventObject(_a) {
    var eventName = _a.eventName, processName = _a.processName, processStartDateTime = _a.processStartDateTime, processActionType = _a.processActionType, stepIndex = _a.stepIndex, stepDateTime = _a.stepDateTime;
    return {
        event: eventName,
        process: {
            name: processName,
            actionType: processActionType,
            processStartDateTime: processStartDateTime,
            step: {
                index: stepIndex,
                dateTime: stepDateTime,
            },
        },
    };
}
exports.getAnalyticsEventObject = getAnalyticsEventObject;
/** Abstraction fn to push analytics payload to datalayer  @deprecated  */
var pushAnalyticsBase = function (event, context, processName, stepIndex, actionType, processStartDateTime) {
    return analyticsPush({
        event: event,
        process: tslib_1.__assign(tslib_1.__assign({ name: "".concat(context).concat(processName ? '.' + processName : ''), actionType: actionType }, (processStartDateTime && { processStartDateTime: processStartDateTime })), { step: {
                index: stepIndex,
                dateTime: Date.now(),
            } }),
    });
};
exports.pushAnalyticsBase = pushAnalyticsBase;
/** Generate analytic fns and hooks @deprecated */
var generateAnalyticsFn = function (event, context) { return ({
    pushAnalyticsBase: exports.pushAnalyticsBase,
    pushAnalytics: function (processName, stepIndex, actionType, processStartDateTime) { return (0, exports.pushAnalyticsBase)(event, context, processName, stepIndex, actionType, processStartDateTime); },
    useAnalyticsLoad: function (processName, stepIndex) {
        (0, react_1.useEffect)(function () {
            (0, exports.pushAnalyticsBase)(event, context, processName, stepIndex, types_1.AnalyticsActionType.LOAD);
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
    },
    useAnalyticsResponse: function (processName, stepIndex) {
        var _a = (0, react_1.useState)(0), startTime = _a[0], setStartTime = _a[1];
        return [
            function () { return setStartTime(Date.now()); },
            function (error) {
                if (error === void 0) { error = false; }
                return (0, exports.pushAnalyticsBase)(event, context, processName, stepIndex, error ? types_1.AnalyticsActionType.ERROR : types_1.AnalyticsActionType.SUCCESS, startTime);
            },
        ];
    },
}); };
exports.generateAnalyticsFn = generateAnalyticsFn;
/** @deprecated */
var generateAnalyticsPushFns = function (event, context) { return ({
    load: function (processName, stepIndex) {
        return analyticsPush({
            event: event,
            process: {
                name: "".concat(context).concat(processName ? '.' + processName : ''),
                actionType: types_1.AnalyticsActionType.LOAD,
                step: {
                    index: "".concat(stepIndex),
                    dateTime: Date.now(),
                },
            },
        });
    },
    click: function (processName, stepIndex) {
        return analyticsPush({
            event: event,
            process: {
                name: "".concat(context, ".").concat(processName),
                actionType: types_1.AnalyticsActionType.CLICK,
                step: {
                    index: "".concat(stepIndex),
                    dateTime: Date.now(),
                },
            },
        });
    },
    apiResponse: function (processName, stepIndex, hasError, processStartDateTime) {
        return analyticsPush({
            event: event,
            process: {
                name: "".concat(context, ".").concat(processName, ".response"),
                actionType: hasError ? types_1.AnalyticsActionType.ERROR : types_1.AnalyticsActionType.SUCCESS,
                processStartDateTime: processStartDateTime,
                step: {
                    index: "".concat(stepIndex),
                    dateTime: Date.now(),
                },
            },
        });
    },
}); };
/** @deprecated */
var useAnalytics = function (event, context) {
    return generateAnalyticsPushFns(event, context);
};
exports.useAnalytics = useAnalytics;
/** @deprecated */
var useAnalyticsLoad = function (event, context, processName, stepIndex) {
    (0, react_1.useEffect)(function () {
        var load = generateAnalyticsPushFns(event, context).load;
        load(processName, stepIndex);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
exports.useAnalyticsLoad = useAnalyticsLoad;
//: [publishStartTime: () => void, pushAPIResponse: (error?: boolean) => void]
/** @deprecated */
var useAnalyticsAPIResponse = function (event, context, processName, stepIndex
// eslint-disable-next-line prettier/prettier
) {
    var _a = (0, react_1.useState)(0), startTime = _a[0], setStartTime = _a[1];
    var apiResponse = generateAnalyticsPushFns(event, context).apiResponse;
    return [
        function () { return setStartTime(Date.now()); },
        function (error) {
            if (error === void 0) { error = false; }
            return apiResponse(processName, stepIndex, error, startTime);
        },
    ];
};
exports.useAnalyticsAPIResponse = useAnalyticsAPIResponse;
//# sourceMappingURL=useAnalytics.js.map